// src/pages/Receiver/GHG/hooks/useGhgFiltersState.js
import { useCallback, useState } from "react";
import { toNumOrNull } from "../utils";

export function useGhgFiltersState() {
  const [hasSearched, setHasSearched] = useState(false);

  // DRAFT
  const [draftMaterials, setDraftMaterials] = useState([]);
  const [draftDonors, setDraftDonors] = useState([]);
  const [draftDonorSearch, setDraftDonorSearch] = useState("");
  const [draftReceiverSearch, setDraftReceiverSearch] = useState("");
  const [draftReceiverOnlyUsed, setDraftReceiverOnlyUsed] = useState(false);

  const [draftEfMin, setDraftEfMin] = useState("");
  const [draftEfMax, setDraftEfMax] = useState("");
  const [draftReMin, setDraftReMin] = useState("");
  const [draftReMax, setDraftReMax] = useState("");
  const [draftNetMin, setDraftNetMin] = useState("");
  const [draftNetMax, setDraftNetMax] = useState("");
  const [draftQtyMin, setDraftQtyMin] = useState("");
  const [draftQtyMax, setDraftQtyMax] = useState("");
  const [draftAvoidedMin, setDraftAvoidedMin] = useState("");
  const [draftAvoidedMax, setDraftAvoidedMax] = useState("");

  // APPLIED
  const [appliedMaterials, setAppliedMaterials] = useState([]);
  const [appliedDonors, setAppliedDonors] = useState([]);
  const [appliedDonorSearch, setAppliedDonorSearch] = useState("");
  const [appliedReceiverSearch, setAppliedReceiverSearch] = useState("");
  const [appliedReceiverOnlyUsed, setAppliedReceiverOnlyUsed] = useState(false);

  const [appliedEfMin, setAppliedEfMin] = useState(null);
  const [appliedEfMax, setAppliedEfMax] = useState(null);
  const [appliedReMin, setAppliedReMin] = useState(null);
  const [appliedReMax, setAppliedReMax] = useState(null);
  const [appliedNetMin, setAppliedNetMin] = useState(null);
  const [appliedNetMax, setAppliedNetMax] = useState(null);
  const [appliedQtyMin, setAppliedQtyMin] = useState(null);
  const [appliedQtyMax, setAppliedQtyMax] = useState(null);
  const [appliedAvoidedMin, setAppliedAvoidedMin] = useState(null);
  const [appliedAvoidedMax, setAppliedAvoidedMax] = useState(null);

  const apply = useCallback(() => {
    setAppliedMaterials(draftMaterials);
    setAppliedDonors(draftDonors);
    setAppliedDonorSearch(draftDonorSearch);
    setAppliedReceiverSearch(draftReceiverSearch);
    setAppliedReceiverOnlyUsed(Boolean(draftReceiverOnlyUsed));

    setAppliedEfMin(toNumOrNull(draftEfMin));
    setAppliedEfMax(toNumOrNull(draftEfMax));
    setAppliedReMin(toNumOrNull(draftReMin));
    setAppliedReMax(toNumOrNull(draftReMax));
    setAppliedNetMin(toNumOrNull(draftNetMin));
    setAppliedNetMax(toNumOrNull(draftNetMax));
    setAppliedQtyMin(toNumOrNull(draftQtyMin));
    setAppliedQtyMax(toNumOrNull(draftQtyMax));
    setAppliedAvoidedMin(toNumOrNull(draftAvoidedMin));
    setAppliedAvoidedMax(toNumOrNull(draftAvoidedMax));

    setHasSearched(true);
  }, [
    draftMaterials,
    draftDonors,
    draftDonorSearch,
    draftReceiverSearch,
    draftReceiverOnlyUsed,
    draftEfMin,
    draftEfMax,
    draftReMin,
    draftReMax,
    draftNetMin,
    draftNetMax,
    draftQtyMin,
    draftQtyMax,
    draftAvoidedMin,
    draftAvoidedMax,
  ]);

  const clear = useCallback(() => {
    setDraftMaterials([]);
    setDraftDonors([]);
    setDraftDonorSearch("");
    setDraftReceiverSearch("");
    setDraftReceiverOnlyUsed(false);

    setDraftEfMin("");
    setDraftEfMax("");
    setDraftReMin("");
    setDraftReMax("");
    setDraftNetMin("");
    setDraftNetMax("");
    setDraftQtyMin("");
    setDraftQtyMax("");
    setDraftAvoidedMin("");
    setDraftAvoidedMax("");

    setAppliedMaterials([]);
    setAppliedDonors([]);
    setAppliedDonorSearch("");
    setAppliedReceiverSearch("");
    setAppliedReceiverOnlyUsed(false);

    setAppliedEfMin(null);
    setAppliedEfMax(null);
    setAppliedReMin(null);
    setAppliedReMax(null);
    setAppliedNetMin(null);
    setAppliedNetMax(null);
    setAppliedQtyMin(null);
    setAppliedQtyMax(null);
    setAppliedAvoidedMin(null);
    setAppliedAvoidedMax(null);

    setHasSearched(false);
  }, []);

  return {
    hasSearched,

    // draft
    draftMaterials,
    setDraftMaterials,
    draftDonors,
    setDraftDonors,
    draftDonorSearch,
    setDraftDonorSearch,
    draftReceiverSearch,
    setDraftReceiverSearch,
    draftReceiverOnlyUsed,
    setDraftReceiverOnlyUsed,

    draftEfMin,
    setDraftEfMin,
    draftEfMax,
    setDraftEfMax,
    draftReMin,
    setDraftReMin,
    draftReMax,
    setDraftReMax,
    draftNetMin,
    setDraftNetMin,
    draftNetMax,
    setDraftNetMax,
    draftQtyMin,
    setDraftQtyMin,
    draftQtyMax,
    setDraftQtyMax,
    draftAvoidedMin,
    setDraftAvoidedMin,
    draftAvoidedMax,
    setDraftAvoidedMax,

    // applied
    appliedMaterials,
    appliedDonors,
    appliedDonorSearch,
    appliedReceiverSearch,
    appliedReceiverOnlyUsed,

    appliedEfMin,
    appliedEfMax,
    appliedReMin,
    appliedReMax,
    appliedNetMin,
    appliedNetMax,
    appliedQtyMin,
    appliedQtyMax,
    appliedAvoidedMin,
    appliedAvoidedMax,

    // actions
    apply,
    clear,
  };
}
